import api from './api';

export const dashboardService = {
  // Get dashboard statistics
  async getDashboardStats() {
    const response = await api.get('/dashboard/stats');
    return response.data;
  }
};